export interface SpidProviderModel {
  id: string;
  logo: string;
  name: string;
}

export interface SpidEntityIdp {
  ['entity_id']: string;
  ['logo_uri']: string;
  ['organization_name']: string;
}
